export const PARENT_CATEGORY_COLORS: Record<string, string> = {
  nurse_midwife: '#E65100', // Orange
  auxiliary: '#9C27B0', // Purple
  medical_doctor: '#283593', // Indigo
  allied_health: '#6D4C41', // Brown
  other: '#9E9E9E', // Grey
};

const CODE_PREFIX_TO_PARENT: Record<string, string> = {
  '1': 'nurse_midwife',
  '2': 'auxiliary',
  '3': 'medical_doctor',
  '4': 'allied_health',
  '5': 'other',
};

export function getCategoryColor(parentCategory: string): string {
  return PARENT_CATEGORY_COLORS[parentCategory] ?? PARENT_CATEGORY_COLORS.other;
}

export function getCategoryColorByCode(code: string): string {
  const prefix = code.split('.')[0];
  const parent = CODE_PREFIX_TO_PARENT[prefix] ?? 'other';
  return getCategoryColor(parent);
}
